function getDecodedBase64String(encodedString: string): string {
  const decodedString = atob(encodedString);
  return decodedString;
}

export { getDecodedBase64String };
